var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniCafe02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#C87A7A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_12593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_12593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.529 229.67C266.66 217.363 299.755 164.315 287.448 111.184C275.141 58.0527 222.093 24.9582 168.962 37.2652C115.831 49.5721 82.7365 102.62 95.0434 155.751C107.35 208.882 160.398 241.976 213.529 229.67Z",
    fill: "#202932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.668 216.854C253.479 216.854 295.48 174.853 295.48 123.042C295.48 71.2315 253.479 29.2305 201.668 29.2305C149.857 29.2305 107.856 71.2315 107.856 123.042C107.856 174.853 149.857 216.854 201.668 216.854Z",
    fill: "#73A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.668 206.979C248.025 206.979 285.605 169.399 285.605 123.042C285.605 76.6853 248.025 39.1055 201.668 39.1055C155.311 39.1055 117.731 76.6853 117.731 123.042C117.731 169.399 155.311 206.979 201.668 206.979Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.669 204.788C246.814 204.788 283.412 168.19 283.412 123.045C283.412 77.9001 246.814 41.3027 201.669 41.3027C156.524 41.3027 119.927 77.9001 119.927 123.045C119.927 168.19 156.524 204.788 201.669 204.788Z",
    fill: "#AE5C4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.362 216.629C165.453 216.938 133.213 195.847 117.668 164.827L165.307 99.4482L165.308 138.607L240.617 141.691L202.362 216.629Z",
    fill: "#2C1B1D",
    fillOpacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.668 161.996C223.18 161.996 240.619 144.557 240.619 123.045C240.619 101.533 223.18 84.0937 201.668 84.0937C180.156 84.0937 162.717 101.533 162.717 123.045C162.717 144.557 180.156 161.996 201.668 161.996Z",
    fill: "#7B9AC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M217.139 92.446L219.86 87.6621L225.894 91.5024L223.097 96.2094L220.628 96.2094L217.336 93.3237L217.139 92.446Z",
    fill: "#7CA6D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M196.336 89.5814L196.183 84.0953L200.802 83.6016L200.846 89.6362L198.739 90.909L196.962 90.2287L196.336 89.5814Z",
    fill: "#7CA6D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M226.443 100.288L229.823 95.9648L235.243 100.628L231.787 104.885L229.351 104.523L226.509 101.188L226.443 100.288Z",
    fill: "#7CA6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.43 161.262C220.736 161.262 237.197 144.967 237.197 124.867C237.197 104.767 220.736 88.4727 200.43 88.4727C180.124 88.4727 163.662 104.767 163.662 124.867C163.662 144.967 180.124 161.262 200.43 161.262Z",
    fill: "#5E74C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.938 115.234L199.145 124.725C199.145 124.725 198.783 129.224 203.172 130.453C208.998 126.437 210.512 125.307 215.998 120.918C212.937 119.283 211.938 115.234 211.938 115.234Z",
    fill: "black",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.259 84.4768C197.74 84.2683 199.244 84.1476 200.78 84.1147L200.857 84.1147L201.131 79.7148C199.507 79.7368 197.905 79.8465 196.336 80.044L196.193 84.4768L196.259 84.4768Z",
    fill: "#D6DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.044 84.7832C215.965 81.5464 209.042 79.7031 201.668 79.7031C201.482 79.7031 201.306 79.7141 201.12 79.7141L200.845 84.103L200.769 84.103C201.065 84.103 201.361 84.103 201.668 84.103C208.087 84.103 214.133 85.661 219.465 88.415L219.443 88.3931L222.033 84.8052L222.044 84.7832Z",
    fill: "#D0D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.836 88.5035C226.014 87.121 224.072 85.8812 222.043 84.7949L219.453 88.3828L219.475 88.4048C221.593 89.491 223.59 90.7638 225.455 92.2121L225.488 92.2121L227.847 88.5035L227.836 88.5035Z",
    fill: "#D6DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08 93.2129C231.456 91.5122 229.701 89.9322 227.825 88.5059L225.466 92.2254L225.433 92.2254C226.969 93.3994 228.395 94.7051 229.734 96.0986L229.734 96.0657L233.069 93.2129L233.08 93.2129Z",
    fill: "#D0D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.083 93.2109L229.736 96.0637L229.736 96.0966C231.338 97.7534 232.787 99.5419 234.059 101.451L237.406 98.5653C236.1 96.6672 234.663 94.8787 233.083 93.2109Z",
    fill: "#D6DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.416 98.5657L234.07 101.451C238.206 107.629 240.62 115.057 240.62 123.045C240.62 144.55 223.185 161.996 201.669 161.996C191.86 161.996 182.896 158.353 176.049 152.362L172.966 155.489C180.613 162.259 190.664 166.374 201.68 166.374C225.61 166.374 245.02 146.964 245.02 123.034C245.02 113.949 242.211 105.522 237.427 98.5547L237.416 98.5657Z",
    fill: "#D0D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.581 147.776C166.04 141.05 162.716 132.437 162.716 123.045C162.716 103.372 177.309 87.111 196.258 84.4777L196.192 84.4777L196.334 80.0449C174.917 82.6782 158.338 100.925 158.338 123.045C158.338 133.6 162.112 143.266 168.377 150.782L171.581 147.787L171.581 147.776Z",
    fill: "#D0D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.582 147.775L168.378 150.771C169.782 152.46 171.318 154.03 172.964 155.489L176.047 152.362C174.435 150.957 172.942 149.421 171.582 147.775Z",
    fill: "#D6DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.057 85.7961C260.783 85.2593 260.492 83.6352 259.408 82.1686C258.324 80.702 256.856 79.9482 256.13 80.4851C255.404 81.0219 255.695 82.6459 256.779 84.1125C257.863 85.5791 259.331 86.3329 260.057 85.7961Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.091 80.5293L211.819 115.333C211.819 115.333 211.72 119.206 215.867 121.027C228.694 110.955 240.862 101.332 260.206 85.6862C256.398 84.4134 256.102 80.5293 256.102 80.5293L256.091 80.5293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.904 103.943L176.893 110.658L180.612 115.409L186.175 118.086L191.859 113.445L193.823 107.345L190.41 103.943L183.904 103.943Z",
    fill: "#6E88E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.135 120.566L177.331 127.281L180.414 132.043L185.012 134.72L189.719 130.068L191.342 123.979L188.523 120.566L183.135 120.566Z",
    fill: "#6E88E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.584 127.26L193.405 132.208L196.159 135.719L200.252 137.694L204.443 134.271L205.892 129.772L203.379 127.26L198.584 127.26Z",
    fill: "#6E88E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.438 242.711V222.914H190.203C194.701 222.914 197.285 225.689 197.285 229.586C197.285 233.537 194.66 236.258 190.094 236.258H186.539V242.711H182.438ZM186.539 232.949H189.438C191.871 232.949 193.061 231.582 193.047 229.586C193.061 227.617 191.871 226.291 189.438 226.277H186.539V232.949ZM201.25 242.957C199.965 242.957 198.926 241.932 198.953 240.66C198.926 239.402 199.965 238.377 201.25 238.391C202.467 238.377 203.52 239.402 203.52 240.66C203.52 241.932 202.467 242.957 201.25 242.957ZM206.855 242.711V222.914H214.621C219.119 222.914 221.703 225.689 221.703 229.586C221.703 233.537 219.078 236.258 214.512 236.258H210.957V242.711H206.855ZM210.957 232.949H213.855C216.289 232.949 217.479 231.582 217.465 229.586C217.479 227.617 216.289 226.291 213.855 226.277H210.957V232.949ZM228.266 222.914V242.711H224.219V222.914H228.266ZM238.137 243.012C233.584 242.998 230.795 240.059 230.809 235.355C230.795 230.775 233.625 227.672 237.973 227.672C241.869 227.672 244.945 230.133 244.945 235.191V236.34H234.801C234.801 238.582 236.127 239.963 238.219 239.977C239.6 239.963 240.584 239.361 240.98 238.473H244.836C244.262 241.221 241.801 242.998 238.137 243.012ZM234.801 233.797H241.117C241.104 231.992 239.859 230.693 238.055 230.707C236.195 230.693 234.883 232.088 234.801 233.797Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCafe02);
export default __webpack_public_path__ + "static/media/mini_cafe_02.e69e2fcc4ddd022fd393cfcf0fded221.svg";
export { ForwardRef as ReactComponent };